import React from 'react';

interface MockCoalitionMember {
    address: string;
    name?: string;
    avatar?: string;
}

interface MockCoalitionData {
    rank: number;
    members: MockCoalitionMember[];
    timesVotedTogether: number;
    percentOfAllProposals: number;
}

const mockCoalitionsData: MockCoalitionData[] = [
    {
        rank: 1,
        members: [
            { address: '0x1234567890123456789012345678901234567890', name: 'alice.eth' },
            { address: '0x2345678901234567890123456789012345678901', name: 'bob.eth' },
        ],
        timesVotedTogether: 45,
        percentOfAllProposals: 89.5,
    },
    {
        rank: 2,
        members: [
            { address: '0x3456789012345678901234567890123456789012', name: 'charlie.eth' },
            { address: '0x4567890123456789012345678901234567890123', name: 'diana.eth' },
        ],
        timesVotedTogether: 38,
        percentOfAllProposals: 76.2,
    },
    {
        rank: 3,
        members: [
            { address: '0x5678901234567890123456789012345678901234', name: 'eve.eth' },
            { address: '0x6789012345678901234567890123456789012345', name: 'frank.eth' },
        ],
        timesVotedTogether: 32,
        percentOfAllProposals: 64.8,
    },
    {
        rank: 4,
        members: [
            { address: '0x7890123456789012345678901234567890123456', name: 'grace.eth' },
            { address: '0x8901234567890123456789012345678901234567', name: 'henry.eth' },
        ],
        timesVotedTogether: 28,
        percentOfAllProposals: 56.4,
    },
    {
        rank: 5,
        members: [
            { address: '0x9012345678901234567890123456789012345678', name: 'iris.eth' },
            { address: '0xa123456789012345678901234567890123456789', name: 'jack.eth' },
        ],
        timesVotedTogether: 24,
        percentOfAllProposals: 48.6,
    },
    {
        rank: 6,
        members: [
            { address: '0xb234567890123456789012345678901234567890', name: 'kate.eth' },
            { address: '0xc345678901234567890123456789012345678901', name: 'luke.eth' },
        ],
        timesVotedTogether: 21,
        percentOfAllProposals: 42.8,
    },
    {
        rank: 7,
        members: [
            { address: '0xd456789012345678901234567890123456789012', name: 'mary.eth' },
            { address: '0xe567890123456789012345678901234567890123', name: 'nick.eth' },
        ],
        timesVotedTogether: 18,
        percentOfAllProposals: 37.2,
    },
    {
        rank: 8,
        members: [
            { address: '0xf678901234567890123456789012345678901234', name: 'olivia.eth' },
            { address: '0x0789012345678901234567890123456789012345', name: 'peter.eth' },
        ],
        timesVotedTogether: 15,
        percentOfAllProposals: 31.4,
    },
];

export const blurredCoalitionsContent = (
    <div style={{ padding: '10px 16px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
            <h4 style={{ fontSize: '16px', fontWeight: 600, color: '#41536A', margin: 0 }}>
                Voting Coalitions
            </h4>
        </div>
        <div style={{ 
            backgroundColor: '#f8f9fa', 
            borderRadius: '10px', 
            border: '1px solid #e0e0e0',
            overflow: 'hidden'
        }}>
            {/* Header */}
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                padding: '10px 26px',
                borderBottom: '1px solid #e0e0e0',
                backgroundColor: '#ffffff',
                fontWeight: 600,
                fontSize: '14px',
                color: '#666'
            }}>
                <div style={{ width: '4%' }}>#</div>
                <div style={{ width: '60%' }}>Coalition</div>
                <div style={{ width: '19%' }}>Voted Together</div>
                <div style={{ width: '17%' }}>% of Proposals</div>
            </div>
            {/* Data rows */}
            {mockCoalitionsData.map((coalition) => (
                <div key={coalition.rank} style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '17px 26px',
                    borderBottom: coalition.rank === mockCoalitionsData.length ? 'none' : '1px solid #e0e0e0',
                    backgroundColor: '#ffffff',
                    fontSize: '14px',
                    color: '#41536A'
                }}>
                    <div style={{ width: '4%', fontWeight: 700 }}>{coalition.rank}</div>
                    <div style={{ width: '60%', display: 'flex', gap: '50px' }}>
                        {coalition.members.map((member, index) => (
                            <div key={index} style={{ fontWeight: 700 }}>
                                {member.name || member.address.slice(0, 8) + '...'}
                            </div>
                        ))}
                    </div>
                    <div style={{ width: '19%' }}>{coalition.timesVotedTogether}</div>
                    <div style={{ width: '17%' }}>{coalition.percentOfAllProposals}%</div>
                </div>
            ))}
        </div>
    </div>
); 